import { setState } from '@lib/systems/state'

export function defaultBoard (options = {}) {
  return {
    poms: options.board ? options.board.poms : [],
    turn: 0,
    whoseTurn: 1,
    numPlayers: 2,
    winner: false,
    opponentMode: options.opponentMode,
    opponentDifficulty: options.difficulty || 0,
    jumpHash: {},
    canJumpTo: null,
    splitHash: {},
    canSplitTo: null,
    selected: null
  }
}

export default function (options = {}) {
  setState('board', defaultBoard(options))
}
